export const couponDuration = {
  FOREVER: 'forever',
  ONE_TIME: 'one_time',
  LIMITED_PERIOD: 'limited_period',
};
